import classNames from 'classnames';
import type { FC, SyntheticEvent } from 'react';
import './Checkbox.css';

export type CheckboxValue = boolean | 'indeterminate';

export interface CheckboxProps {
  disabled?: boolean;
  value: CheckboxValue;
  onChange?: (value: boolean) => void;
}

export const Checkbox: FC<CheckboxProps> = (props) => {
  const handleClick = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();

    props.onChange?.(props.value === 'indeterminate' ? true : !props.value);
  };

  const content = (
    <>
      {props.value === true && (
        <i className='fa fa-check ipf-checkbox__checkmark' />
      )}
      {props.value === 'indeterminate' && (
        // intentionally didn't use fa-dash icon, it messes up centering:
        // when the checkbox is centered in odd-width container on non-retina screen,
        // the glyph spreads over subpixels shifted to left a bit (at least in Chrome).
        <span className='ipf-checkbox__indeterminate-glyph' />
      )}
    </>
  );

  return props.onChange ? (
    <button
      type='button'
      className='ipf-checkbox'
      disabled={props.disabled}
      onClick={handleClick}
    >
      {content}
    </button>
  ) : (
    <div
      className={classNames(
        'ipf-checkbox',
        props.disabled && 'ipf-checkbox--disabled',
      )}
    >
      {content}
    </div>
  );
};
